// import '../scss/index.scss';
import 'parsleyjs';
import PartnerListFilter from './partnerlistfilter';

document.addEventListener('DOMContentLoaded', function () {
    window.partnerListFilter = new PartnerListFilter('.partnerlist');
    window.partnerListFilter.init();
});